module.exports = __webpack_public_path__ + "img/main-list_05.a949b6e5.jpg";